import {
  Ticket,
  Comment,
  HelpdeskNotification,
  TicketCategory,
  TicketPriority,
  TicketStatus,
  NotificationType
} from '../types';

function mapTicket(raw: unknown): Ticket {
  const r = raw as Record<string, unknown>;
  return {
    id: (r._id ?? r.id) as string,
    title: r.title as string,
    description: r.description as string,
    stepsToReproduce: r.stepsToReproduce as string | undefined,
    category: r.category as TicketCategory,
    priority: r.priority as TicketPriority,
    status: r.status as TicketStatus,
    reportedBy: r.reportedBy as Ticket['reportedBy'],
    assignedTo: (r.assignedTo as Ticket['assignedTo']) ?? null,
    attachments: (r.attachments as Ticket['attachments']) ?? [],
    trelloCardUrl: (r.trelloCardUrl as string) ?? null,
    aiSummary: (r.aiSummary as string) ?? null,
    createdAt: r.createdAt as string,
    updatedAt: r.updatedAt as string,
    resolvedAt: r.resolvedAt as string | undefined
  };
}

function mapComment(raw: unknown): Comment {
  const r = raw as Record<string, unknown>;
  return {
    id: (r._id ?? r.id) as string,
    ticketId: r.ticketId as string,
    body: r.body as string,
    author: r.author as Comment['author'],
    createdAt: r.createdAt as string
  };
}

function mapNotification(raw: unknown): HelpdeskNotification {
  const r = raw as Record<string, unknown>;
  const d = (r.data ?? {}) as Record<string, unknown>;
  return {
    id: (r.id ?? r._id) as string,
    recipientUserId: (r.userId ?? r.recipientUserId) as string,
    type: (d.notificationType ?? r.type) as NotificationType,
    ticketId: (d.ticketId ?? r.ticketId) as string,
    ticketTitle: (d.ticketTitle ?? r.ticketTitle) as string,
    message: (d.message ?? r.message) as string,
    read: Boolean(r.isRead ?? r.read),
    createdAt: r.createdAt as string
  };
}

export const ticketMapper = { mapTicket, mapComment, mapNotification };
